import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { StrapiService } from '../../services/strapi.service';
import { SeoService } from '../../services/seo.service';
import { EventInfoArticleComponent } from '../event-info-article/event-info-article.component';
import { EventIntroArticleComponent } from '../event-intro-article/event-intro-article.component';
import { SectionsComponent } from '../sections/sections.component';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { CommonModule } from '@angular/common';
import { SponsorBannerComponent } from '../sponsor-banner/sponsor-banner.component';

@Component({
  selector: 'app-event-info',
  imports: [
    EventInfoArticleComponent,
    EventIntroArticleComponent,
    SectionsComponent,
    SponsorBannerComponent,
    RouterModule,
    CommonModule
  ],
  templateUrl: './event-info.component.html',
  styleUrl: './event-info.component.less',
})
export class EventInfoComponent {
  private activatedRoute = inject(ActivatedRoute);
  private strapiService = inject(StrapiService);
  private seoService = inject(SeoService);
  public event: any;

  public sponsors$!: Observable<any>;
  private readonly store = inject(Store);

  ngOnInit(): void {
     this.sponsors$ = this.store.select((state) => {
      return state.globalData?.sponsors;
    });

    this.activatedRoute.paramMap.subscribe(params => {
      const event = params.get('event');

      this.strapiService.getEventInfo(event!).subscribe({
        next: (event) => {
          this.event = event;

console.log('Loaded event info:', event);

          if (event?.seo) {
            this.seoService.updateSeo(event.seo);
          }
        }
      });
    });
  }
}
